module.exports = __webpack_public_path__ + "static/media/abricot.22677eea.svg";